const getCampoObrigatorioClassName = (valor) => {
  if (valor && valor !== '' && valor !== '0' && valor !== 0) return '';

  return 'campo-obrigatorio';
};

export default getCampoObrigatorioClassName;
